export default "__VITE_ASSET__BT87Sn71__"